import React, { FC } from 'react';
import BananatagButton from '../../../componentLibrary/BananatagButton';
import imageSources from '../../../constants/imageSources/imageSources';
import * as Styled from './styles';

interface IProps {
    staffbaseUrl: string;
}

const Create: FC<IProps> = ({ staffbaseUrl }) => (
    <div style={{ textAlign: 'center' }}>
        <img src={imageSources.STAFFBASE.NO_POSTS} alt="" width="130" />
        <Styled.Text>No news posts yet</Styled.Text>
        <BananatagButton
            text="Create a post"
            size="medium"
            styling={{ width: 178, justifyContent: 'center' }}
            onClick={() => {
                window.open(staffbaseUrl, '_blank', 'noopener,noreferrer');
            }}
        />
        <Styled.FooterText>
            You&apos;ll be redirected to the Staffbase Experience Studio in a new tab to create a new post.
        </Styled.FooterText>
    </div>
);

export default Create;
